var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import useSidebarStore from '../dataLayer/hooks/UseSidebarStore';
import { Sidebar as SemanticSidebar } from 'semantic-ui-react';
import useTheme from '../../../../themes/hooks/UseTheme';
import { observer } from 'mobx-react';
import './SidebarImplementationOverwrites.css';
var SidebarImplementation = function (props) {
    var sidebarKey = props.sidebarKey, children = props.children, customStyle = props.customStyle, disableHideOnBackdropPress = props.disableHideOnBackdropPress;
    var sidebarStore = useSidebarStore();
    var _a = __read(useState(false), 2), isOpen = _a[0], setIsOpen = _a[1];
    var theme = useTheme();
    var styleObject = theme.advancedControlsThemes.sidebar.getStyleObjectBuilder(props, 'backgroundColor', 'width')
        .withCustomStyle(customStyle)
        .withBaseStyle({
        display: 'flex'
    })
        .build();
    return React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: 'absolute',
                top: -1,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: isOpen ? 2000 : -1,
                background: 'rgba(0,0,0,0.8)',
                transition: 'all 1s ease'
            } }),
        React.createElement(SemanticSidebar, { onVisible: function () {
                setIsOpen(true);
            }, onHidden: function () {
                setIsOpen(false);
            }, animation: 'overlay', direction: 'right', style: styleObject, vertical: "true", onHide: function () {
                disableHideOnBackdropPress ? undefined : sidebarStore.closeSidebar();
            }, visible: sidebarStore.isOpen(sidebarKey) }, children));
};
export default observer(SidebarImplementation);
//# sourceMappingURL=SidebarImplementation.js.map